import React, {useState} from "react";
import {Multipartheader} from "../../Components/Url/ApiUrl";
import swal from 'sweetalert';
import axios from "axios";
import {useTranslation} from "react-i18next";
const AddArea = ({show, handleClose, regions, onSuccess}) => {
    const {t} = useTranslation();
    const [regionId, setRegionId] = useState('');
    const [diplom, setDiplom] = useState(null);
    const [cv, setCv] = useState(null);
    const [sertifikat, setSertifikat] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!regionId) {
            await swal(t('warning'), t('please_choose_area'), "warning");
            return;
        }

        const formData = new FormData();
        formData.append('region_id', regionId);
        if (diplom) formData.append('diplom', diplom);
        if (cv) formData.append('cv', cv);
        if (sertifikat) formData.append('sertifikat', sertifikat);

        try {
            const res = await axios
                .post(
                    process.env.REACT_APP_API_ENDPOINT + '/company/operationarea',
                    formData,
                    {
                        headers:Multipartheader
                    });
            if (!res.data || !res.data?.success) {
                const message = res.data?.message;
                let firstError = t('translation:saving_error');
                if (message && typeof message === 'object') {
                    const firstKey = Object.keys(message)[0];
                    if (firstKey && Array.isArray(message[firstKey])) {
                        firstError = message[firstKey][0];
                    }
                }else{
                    firstError = res.data?.message;
                }

                swal(t('error'), firstError, "error");
                throw new Error(firstError);
            }
            await swal(t('saved'), t('area_add_success'), "success");
            handleClose();
            onSuccess();
        } catch (err) {
            swal(t('error'), err.message || t('translation:unknown_error'), "error");
        }
    };

    if (!show) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-lg ">
                <div className="modal-content p-5">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('translation:add_operation_area')}</h5>
                            <button type="button" className="btn-close" onClick={handleClose}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">{t('translation:choose_operation_area')}</label>
                                <select className="form-select" value={regionId}
                                        onChange={(e) => setRegionId(e.target.value)}>
                                    <option value="">---{t('translation:not_choosen')}---</option>
                                    {regions.map((region) => (
                                        <option key={region.id} value={region.id}>{region.name_l}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">{t('upload_diploms')}</label>
                                <input type="file" accept="application/pdf" className="form-control"
                                       onChange={(e) => setDiplom(e.target.files[0])}/>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">{t('upload_cv')}</label>
                                <input type="file" accept="application/pdf" className="form-control"
                                       onChange={(e) => setCv(e.target.files[0])}/>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">{t('upload_certificates')}</label>
                                <input type="file" accept="application/pdf" className="form-control"
                                       onChange={(e) => setSertifikat(e.target.files[0])}/>
                            </div>
                            <p className="text-muted"><strong>{t('remember')}</strong> <small>{t('request_specialists')}</small></p>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success">{t('save')}</button>
                            <button type="button" className="btn btn-secondary" onClick={handleClose}>{t('translation:cancel')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddArea;
